import api from './axios'

/**
 * Get activity logs for a specific entity
 * @param {string} entityType - Type of entity (contract, trainer, team, etc.)
 * @param {number} entityId - ID of the entity
 * @param {number} limit - Number of logs to fetch
 * @returns {Promise<Array>}
 */
export const getEntityActivityLogs = async (entityType, entityId, limit = 20) => {
  const response = await api.get(`/activity-logs/entity/${entityType}/${entityId}`, {
    params: { limit }
  })
  return response.data
}

/**
 * Get recent activity logs
 * @param {number} limit - Number of logs to fetch
 * @returns {Promise<Array>}
 */
export const getRecentActivityLogs = async (limit = 10) => {
  const response = await api.get('/activity-logs/recent', {
    params: { limit }
  })
  return response.data
}

/**
 * Get all activity logs with filters
 * @param {object} params - Filter parameters
 * @returns {Promise<{data: Array, pagination: object}>}
 */
export const getActivityLogs = async (params = {}) => {
  const response = await api.get('/activity-logs', { params })
  return response.data
}

/**
 * Delete activity logs by action pattern
 * @param {string} action - Action pattern to delete (e.g., "viewed")
 * @returns {Promise<object>}
 */
export const deleteByAction = async (action) => {
  const response = await api.post('/activity-logs/delete-by-action', { action })
  return response.data
}